// api接口文件
// var SERVER_DOMAIN = window.location.host;
// SERVER_DOMAIN = 'localhost:11090'
var SERVER_HOST = '/api'
// var SERVER_HOST = window.location.protocol + '//manage.taoxiaobao.click:81/api';
// var SERVER_HOST = window.location.protocol + '//yyg.douy.net/api';
// var SERVER_HOST = window.location.protocol + '//192.168.50.231:11090/api'; // 邹哥本地
// var SERVER_HOST = window.location.protocol + '//3fd3ly690844.vicp.fun/api'; // 韦贵阳本地
// var SERVER_HOST = window.location.protocol + '//192.168.50.249:11090/api'; // 韦贵阳本地

// console.log(SERVER_HOST)
if (SERVER_HOST.indexOf('localhost') >= 0) {
  SERVER_HOST = '/api';
}
const SERVER_HOST_MANAGER = SERVER_HOST + '/';
const API = {
  user: {
    login: {   //登录POST /change/password
      url: SERVER_HOST_MANAGER + 'doLogin',
      method: 'POST'
    },
    password: {   //修改密码
      url: SERVER_HOST_MANAGER + 'change/password',
      method: 'POST'
    },
  },
  appusers: {
    list: {   //注册用户列表
      url: SERVER_HOST_MANAGER + 'appusers/list',
      method: 'POST'
    },
    disable: {   //修改用户状态
      url: SERVER_HOST_MANAGER + 'appusers/disable',
      method: 'POST'
    },
    detailAddress: {   // 用户详情-收货地址
      url: SERVER_HOST_MANAGER + 'appusers/detailAddress',
      method: 'GET'
    },
    detailInvitationRecord: {   // 用户详情-邀请记录
      url: SERVER_HOST_MANAGER + 'appusers/detailInvitationRecord',
      method: 'POST'
    },
    detailInfo: {   // 用户详情-基础信息展示
      url: SERVER_HOST_MANAGER + 'appusers/detailInfo',
      method: 'GET'
    },
    delete: {   //删除用户
      url: SERVER_HOST_MANAGER + 'appusers/delete',
      method: 'GET'
    },
    addBlackLis: {   // 添加黑名单GET /appusers/
      url: SERVER_HOST_MANAGER + 'userDetail/addBlackLis',
      method: 'POST'
    },
    detailPersonalData: {   //个人大数据
      url: SERVER_HOST_MANAGER + 'appusers/detailPersonalData',
      method: 'GET'
    },
  },
  // 代理用户
  appuseragencys: {
    // 查询代理用户
    list: {
      url: SERVER_HOST_MANAGER + 'appuseragencys/list',
      method: 'POST'
    },
    // 设置代理用户
    update: {
      url: SERVER_HOST_MANAGER + 'appuseragencys/update',
      method: 'POST'
    },
    // 添加代理用户
    add: {
      url: SERVER_HOST_MANAGER + 'appuseragencys/add',
      method: 'POST'
    },
    // 取消代理用户
    delete: {
      url: SERVER_HOST_MANAGER + 'appuseragencys/delete',
      method: 'GET'
    },
    // 代理用户详情-基础信息展示
    detail: {
      url: SERVER_HOST_MANAGER + 'appuseragencys/detail',
      method: 'GET'
    },
    // 回显代理内容
    review: {
      url: SERVER_HOST_MANAGER + 'appuseragencys/review',
      method: 'GET'
    },
    // 列表分佣记录
    rewardRecordList: {
      url: SERVER_HOST_MANAGER + 'appuseragencys/rewardRecordList',
      method: 'POST'
    },
  },
  // 回收信息
  bthuishourecords: {
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'bthuishourecords/list',
      method: 'POST'
    },
  },
  // 黑名单
  appUserBlacklist: {
    // 查询列表
    list: {
      url: SERVER_HOST_MANAGER + 'appUserBlacklist/list',
      method: 'POST'
    },
    // 查询详情
    detail: {
      url: SERVER_HOST_MANAGER + 'appUserBlacklist/detail',
      method: 'GET'
    },
    // 移除黑名单
    delete: {
      url: SERVER_HOST_MANAGER + 'appUserBlacklist/delete',
      method: 'GET'
    },
    // 编辑
    update: {
      url: SERVER_HOST_MANAGER + 'appUserBlacklist/update',
      method: 'POST'
    },
    // 添加
    add: {
      url: SERVER_HOST_MANAGER + 'appUserBlacklist/add',
      method: 'POST'
    }
  },
  //白名单
  appUserWhitelist: {
    delete: {   //删除白名单用户
      url: SERVER_HOST_MANAGER + 'appUserWhitelist/delete',
      method: 'GET'
    },
    cities: {  //获取市级下拉列表
      url: SERVER_HOST_MANAGER + 'appUserWhitelist/cities',
      method: 'GET'
    },
    province: {  //获取省级下拉列表
      url: SERVER_HOST_MANAGER + 'appUserWhitelist/province',
      method: 'POST'
    },
    list: {  //白名单多条件查询
      url: SERVER_HOST_MANAGER + 'appUserWhitelist/list',
      method: 'POST'
    },
    add: {  //添加白名单
      url: SERVER_HOST_MANAGER + 'appUserWhitelist/add',
      method: 'POST'
    },
    update: {  //编辑白名单
      url: SERVER_HOST_MANAGER + 'appUserWhitelist/update',
      method: 'POST'
    },
    disable: {   //修改白名单用户状态
      url: SERVER_HOST_MANAGER + 'appUserWhitelist/disable',
      method: 'POST'
    },
    review: {   //回显编辑白名单信息
      url: SERVER_HOST_MANAGER + 'appUserWhitelist/review',
      method: 'GET'
    },
  },
  //昵称审核
  appnicknameaudits: {
    examine: {   //昵称审核
      url: SERVER_HOST_MANAGER + 'appnicknameaudits/examine',
      method: 'POST'
    },
    list: {  //列表
      url: SERVER_HOST_MANAGER + 'appnicknameaudits/list',
      method: 'POST'
    },
  },
  //验证码记录
  btsmssends: {
    getCodes: {   //验证码详情
      url: SERVER_HOST_MANAGER + 'btsmssends/getCodes',
      method: 'GET'
    },
    list: {  //列表
      url: SERVER_HOST_MANAGER + 'btsmssends/list',
      method: 'POST'
    },
    deleteByPhones: {  //删除
      url: SERVER_HOST_MANAGER + 'btsmssends/deleteByPhones',
      method: 'POST'
    },
  },
  // 订单
  btorders: {
    close: { // 关闭订单
      url: SERVER_HOST_MANAGER + 'btorders/close',
      method: 'POST'
    },
    deliver: { // 订单发货
      url: SERVER_HOST_MANAGER + 'btorders/deliver',
      method: 'POST'
    },
    tracking: { // 订单跟踪 （缺少一位参数，第三方物流）
      url: SERVER_HOST_MANAGER + 'btorders/tracking',
      method: 'GET'
    },
    list: { // 查询订单
      url: SERVER_HOST_MANAGER + 'btorders/list',
      method: 'POST'
    },
    logistics: { // 物流列表
      url: SERVER_HOST_MANAGER + 'btorders/logistics',
      method: 'POST'
    },
    detail: { // 按id查询详情
      url: SERVER_HOST_MANAGER + 'btorders/detail',
      method: 'GET'
    },
    detailAdd: { // 订单详情-收货人信息
      url: SERVER_HOST_MANAGER + 'btorders/detailAdd',
      method: 'GET'
    },
    detailGoods: { // 订单详情-商品信息
      url: SERVER_HOST_MANAGER + 'btorders/detailGoods',
      method: 'GET'
    },
    detailInfo: { // 订单详情-基础信息
      url: SERVER_HOST_MANAGER + 'btorders/detailInfo',
      method: 'GET'
    },
    detailOperation: { // 订单详情-操作信息
      url: SERVER_HOST_MANAGER + 'btorders/detailOperation',
      method: 'GET'
    },
    consigneeInformation: { // 修改收货人信息
      url: SERVER_HOST_MANAGER + 'btorders/consigneeInformation',
      method: 'POST'
    },
    detailCost: { // 费用信息
      url: SERVER_HOST_MANAGER + 'btorders/detailCost',
      method: 'GET'
    },
    reviewConsigneeInformation: { // 回显修改收货人信息
      url: SERVER_HOST_MANAGER + 'btorders/reviewConsigneeInformation',
      method: 'GET'
    },
    // -------------------自提
    ztClose: { // 关闭订单
      url: SERVER_HOST_MANAGER + 'btorders/ztClose',
      method: 'POST'
    },
    ztDeliver: { // 订单发货
      url: SERVER_HOST_MANAGER + 'btorders/deliver',
      method: 'POST'
    },
    ztTracking: { // 订单跟踪 （缺少一位参数，第三方物流）
      url: SERVER_HOST_MANAGER + 'btorders/tracking',
      method: 'GET'
    },
    ztList: { // 查询订单
      url: SERVER_HOST_MANAGER + 'btorders/ztList',
      method: 'POST'
    },
    ztLogistics: { // 物流列表
      url: SERVER_HOST_MANAGER + 'btorders/logistics',
      method: 'POST'
    },
    ztDetail: { // 按id查询详情
      url: SERVER_HOST_MANAGER + 'btorders/detail',
      method: 'GET'
    },
    detailZtAdd: { // 订单详情-收货人信息
      url: SERVER_HOST_MANAGER + 'btorders/detailZtAdd',
      method: 'GET'
    },
    detailZtGoods: { // 订单详情-商品信息
      url: SERVER_HOST_MANAGER + 'btorders/detailZtGoods',
      method: 'GET'
    },
    ztDetailInfo: { // 订单详情-基础信息
      url: SERVER_HOST_MANAGER + 'btorders/ztDetailInfo',
      method: 'GET'
    },
    detailZtOperation: { // 订单详情-操作信息
      url: SERVER_HOST_MANAGER + 'btorders/detailZtOperation',
      method: 'GET'
    },
    ztConsigneeInformation: { // 修改收货人信息
      url: SERVER_HOST_MANAGER + 'btorders/consigneeInformation',
      method: 'POST'
    },
    detailZtCost: { // 费用信息
      url: SERVER_HOST_MANAGER + 'btorders/detailZtCost',
      method: 'GET'
    },
    ztReviewConsigneeInformation: { // 回显修改收货人信息
      url: SERVER_HOST_MANAGER + 'btorders/reviewConsigneeInformation',
      method: 'GET'
    },
    supplier: { // 自提点下拉列表
      url: SERVER_HOST_MANAGER + 'btorders/supplier',
      method: 'POST'
    },
    updateZtInfo: { // 修改自提点
      url: SERVER_HOST_MANAGER + 'btorders/updateZtInfo',
      method: 'POST'
    },
  },
  // 商品
  btgoodss: {
    add: { // 新增
      url: SERVER_HOST_MANAGER + 'btgoodss/add',
      method: 'POST'
    },
    list: { // 列表
      url: SERVER_HOST_MANAGER + 'btgoodss/list',
      method: 'POST'
    },
    changeInventory: { // 修改库存
      url: SERVER_HOST_MANAGER + 'btgoodss/changeInventory',
      method: 'POST'
    },
    changeStatus: { // 上下架商品
      url: SERVER_HOST_MANAGER + 'btgoodss/changeStatus',
      method: 'GET'
    },
    delete: { // 删除
      url: SERVER_HOST_MANAGER + 'btgoodss/delete',
      method: 'GET'
    },
    detail: { // 按id查询详情
      url: SERVER_HOST_MANAGER + 'btgoodss/detail',
      method: 'GET'
    },
    review: { // 回显编辑信息
      url: SERVER_HOST_MANAGER + 'btgoodss/review',
      method: 'GET'
    },
    update: { // 编辑商品信息
      url: SERVER_HOST_MANAGER + 'btgoodss/update',
      method: 'POST'
    },
    priceList: { // 查询价格历史记录
      url: SERVER_HOST_MANAGER + 'btgoodss/priceList',
      method: 'GET'
    },
    classifyDraw: { // 查询普通商品分类列表
      url: SERVER_HOST_MANAGER + 'btgoodss/classifyDraw',
      method: 'POST'
    },
    classifyType: { // 通过type获取商品类目
      url: SERVER_HOST_MANAGER + 'btgoodss/classifyType',
      method: 'POST'
    }
  },
  // 拼团商品
  btgroupgoods: {
    add: { // 新增
      url: SERVER_HOST_MANAGER + 'btgroupgoods/add',
      method: 'POST'
    },
    list: { // 列表
      url: SERVER_HOST_MANAGER + 'btgroupgoods/list',
      method: 'POST'
    },
    detail: { // 按id查询详情
      url: SERVER_HOST_MANAGER + 'btgroupgoods/detail',
      method: 'GET'
    },
    delete: { // 删除
      url: SERVER_HOST_MANAGER + 'btgroupgoods/delete',
      method: 'GET'
    },
    update: { // 更新
      url: SERVER_HOST_MANAGER + 'btgroupgoods/update',
      method: 'POST'
    },
    changeStatus: { // 上下架商品
      url: SERVER_HOST_MANAGER + 'btgroupgoods/changeStatus',
      method: 'GET'
    },
  },
  // 拼团商品订单
  btordersGroup: {
    list: {  //列表数据
      url: SERVER_HOST_MANAGER + 'btorders/group/list',
      method: 'POST'
    },
    updateExpress: {  // 更新物流单号
      url: SERVER_HOST_MANAGER + 'btlogistics/updateExpress',
      method: 'POST'
    },
  },
  // 抽奖商品
  btdrawgoodss: {
    list: {  //列表数据
      url: SERVER_HOST_MANAGER + 'btdrawgoodss/list',
      method: 'POST'
    },
    add: {  //新增数据
      url: SERVER_HOST_MANAGER + 'btdrawgoodss/add',
      method: 'POST'
    },
    delete: {  //删除数据
      url: SERVER_HOST_MANAGER + 'btdrawgoodss/delete',
      method: 'DELETE'
    },
    changeInventory: {  // 修改库存
      url: SERVER_HOST_MANAGER + 'btdrawgoodss/changeInventory',
      method: 'POST'
    },
    addPeriod: {  // 添加周期
      url: SERVER_HOST_MANAGER + 'btdrawgoodss/addPeriod',
      method: 'POST'
    },
    classifyDraw: {  //查询抽奖商品分类列表
      url: SERVER_HOST_MANAGER + 'btdrawgoodss/classifyDraw',
      method: 'POST'
    },
    periodList: {  //开奖周期下拉列表
      url: SERVER_HOST_MANAGER + 'btdrawgoodss/periodList',
      method: 'POST'
    },
    review: {  //回显抽奖商品
      url: SERVER_HOST_MANAGER + 'btdrawgoodss/review',
      method: 'GET'
    },
    update: {  // 编辑抽奖商品
      url: SERVER_HOST_MANAGER + 'btdrawgoodss/update',
      method: 'POST'
    },
    updateStatus: {  // 上下架
      url: SERVER_HOST_MANAGER + 'btdrawgoodss/updateStatus',
      method: 'POST'
    },
  },
  //订单详情
  orderDetail: {
    basicInfo: {   //订单详情页-基础信息
      url: SERVER_HOST_MANAGER + 'orderDetail/basicInfo',
      method: 'GET'
    },
    consigneeInfo: {   //订单详情页-收货人信息
      url: SERVER_HOST_MANAGER + 'orderDetail/consigneeInfo',
      method: 'GET'
    },
    costInfo: {    //订单详情页-费用信息
      url: SERVER_HOST_MANAGER + 'orderDetail/costInfo',
      method: 'GET'
    },
    findProvinces: {    //收货人地址，三级联动省级列表
      url: SERVER_HOST_MANAGER + 'orderDetail/findProvinces',
      method: 'GET'
    },
    handlingInfo: {    //订单详情页-操作信息
      url: SERVER_HOST_MANAGER + 'orderDetail/handlingInfo',
      method: 'GET'
    },
    itemInfo: {    //订单详情页-商品信息
      url: SERVER_HOST_MANAGER + 'orderDetail/itemInfo',
      method: 'GET'
    },
    proCityCounty: {    //收货人地址，三级联动市/区列表
      url: SERVER_HOST_MANAGER + 'orderDetail/proCityCounty',
      method: 'GET'
    },
    echoConsignee: {    //详情页-回显收货人信息
      url: SERVER_HOST_MANAGER + 'orderDetail/echoConsignee',
      method: 'GET'
    },
    changeConsignee: {    //详情页-修改收货人信息
      url: SERVER_HOST_MANAGER + 'orderDetail/changeConsignee',
      method: 'POST'
    },
  },
  // 类目管理
  btclassifys: {
    // 修改类目状态
    disable: {
      url: SERVER_HOST_MANAGER + 'btclassifys/disable',
      method: 'POST'
    },
    // 删除
    delete: {
      url: SERVER_HOST_MANAGER + 'btclassifys/delete',
      method: 'GET'
    },
    // 分类下拉
    classifyAll: {
      url: SERVER_HOST_MANAGER + 'btclassifys/classifyAll',
      method: 'GET'
    },
    // 添加
    add: {
      url: SERVER_HOST_MANAGER + 'btclassifys/add',
      method: 'POST'
    },
    // 多条件查询列表
    list: {
      url: SERVER_HOST_MANAGER + 'btclassifys/list',
      method: 'POST'
    },
    // 编辑
    update: {
      url: SERVER_HOST_MANAGER + 'btclassifys/update',
      method: 'POST'
    }
  },
  // 抽奖类目管理
  btclassifytags: {
    // 修改类目状态
    disable: {
      url: SERVER_HOST_MANAGER + 'btclassifytags/disable',
      method: 'POST'
    },
    // 删除
    delete: {
      url: SERVER_HOST_MANAGER + 'btclassifytags/delete',
      method: 'POST'
    },
    // 添加
    add: {
      url: SERVER_HOST_MANAGER + 'btclassifytags/add',
      method: 'POST'
    },
    // 多条件查询列表
    list: {
      url: SERVER_HOST_MANAGER + 'btclassifytags/list',
      method: 'POST'
    },
    // 回显详情
    review: {
      url: SERVER_HOST_MANAGER + 'btclassifytags/review',
      method: 'GET'
    },
    // 编辑
    update: {
      url: SERVER_HOST_MANAGER + 'btclassifytags/update',
      method: 'POST'
    }
  },
  // 自提订单
  selfMention: {
    basicInfo: {  // 自提订单详情-基础信息
      url: SERVER_HOST_MANAGER + 'selfMention/basicInfo',
      method: 'GET'
    },
    changeSelfMentionPoints: { // 自提订单详情-修改用户自提点
      url: SERVER_HOST_MANAGER + 'selfMention/changeSelfMentionPoints',
      method: 'POST'
    },
    consigneeInfo: { // 自提订单详情-自提用户信息
      url: SERVER_HOST_MANAGER + 'selfMention/consigneeInfo',
      method: 'GET'
    },
    costInfo: { // 自提订单详情-费用信息
      url: SERVER_HOST_MANAGER + 'selfMention/costInfo',
      method: 'GET'
    },
    handlingInfo: { // 自提订单详情-操作信息
      url: SERVER_HOST_MANAGER + 'selfMention/handlingInfo',
      method: 'GET'
    },
    itemInfo: {   //自提订单详情-商品信息
      url: SERVER_HOST_MANAGER + 'selfMention/itemInfo',
      method: 'GET'
    },
    selectOrder: { // 多条件查询自提订单
      url: SERVER_HOST_MANAGER + 'selfMention/selectOrder',
      method: 'POST'
    },
    selfMentionPoints: {   //自提订单详情-查询自提点下拉列表
      url: SERVER_HOST_MANAGER + 'selfMention/selfMentionPoints',
      method: 'GET'
    },
  },
  //权限管理系统用户
  sysusers: {
    myInfo: {  //获取个人信息POST /sysusers/add
      url: SERVER_HOST_MANAGER + 'sysusers/myInfo',
      method: 'GET'
    },
    list: {  //列表
      url: SERVER_HOST_MANAGER + 'sysusers/list',
      method: 'POST'
    },
    listAll: {  //列表(不分页)
      url: SERVER_HOST_MANAGER + 'sysusers/listAll',
      method: 'POST'
    },
    add: {  //添加
      url: SERVER_HOST_MANAGER + 'sysusers/add',
      method: 'POST'
    },
    delete: {  //删除
      url: SERVER_HOST_MANAGER + 'sysusers/delete',
      method: 'POST'
    },
    detail: {  //添加
      url: SERVER_HOST_MANAGER + 'sysusers/detail',
      method: 'GET'
    },
    update: {  //更新
      url: SERVER_HOST_MANAGER + 'sysusers/update',
      method: 'POST'
    },
    roleAll: {  //角色下拉列表
      url: SERVER_HOST_MANAGER + 'sysusers/roleAll',
      method: 'POST'
    },
    disable: {  //角色下拉列表
      url: SERVER_HOST_MANAGER + 'sysusers/disable',
      method: 'POST'
    }
  },
  //文件上传
  file: {
    upload: {  //图片上传
      url: SERVER_HOST_MANAGER + 'file/upload',
      method: 'POST'
    },
    reUpload: {  //图片上传替换
      url: SERVER_HOST_MANAGER + 'file/reUpload',
      method: 'POST'
    },
    uploadZoom: {  //缩略图片上传
      url: SERVER_HOST_MANAGER + 'file/uploadZoom',
      method: 'POST'
    },
    getStringBizId: {  //生成id
      url: SERVER_HOST_MANAGER + 'file/getStringBizId',
      method: 'GET'
    },
    uploadMulti: {  //多文件上传
      url: SERVER_HOST_MANAGER + 'file/uploadMulti',
      method: 'POST'
    },
    ossUpload: {  //oss文件上传
      url: SERVER_HOST_MANAGER + 'file/ossUpload',
      method: 'POST'
    },
  },
  // 卡密
  btvirtualgoodsinventorys: {
    import: {
      url: SERVER_HOST_MANAGER + 'btvirtualgoodsinventorys/import',
      method: 'POST'
    },
    export: {
      url: SERVER_HOST_MANAGER + 'btvirtualgoodsinventorys/export',
      method: 'POST'
    },
    list: { // 卡密列表
      url: SERVER_HOST_MANAGER + 'btvirtualgoodsinventorys/list',
      method: 'POST'
    }
  },
  //文件管理
  attachs: {
    delete: {  //根据id删除图片
      url: SERVER_HOST_MANAGER + 'attachs/delete',
      method: 'POST'
    },
    list: {  //商品
      url: SERVER_HOST_MANAGER + 'attachs/list',
      method: 'POST'
    },
    sortByBizId: {  //根据List ID 排序
      url: SERVER_HOST_MANAGER + 'attachs/sortByBizId',
      method: 'POST'
    },
    detailLastByBizId: {  //根据业务id查询图片id
      url: SERVER_HOST_MANAGER + 'attachs/detailLastByBizId',
      method: 'GET'
    },
  },
  // 供应商
  btsuppliers: {
    list: {  // 供应商列表
      url: SERVER_HOST_MANAGER + 'btsuppliers/list',
      method: 'POST'
    },
    all: {  // 供应商列表
      url: SERVER_HOST_MANAGER + 'btsuppliers/all',
      method: 'POST'
    },
    delete: {  //删除供应商
      url: SERVER_HOST_MANAGER + 'btsuppliers/delete',
      method: 'GET'
    },
    detail: {  //供应商详情
      url: SERVER_HOST_MANAGER + 'btsuppliers/detail',
      method: 'GET'
    },
    add: {  // 供应商列表添加
      url: SERVER_HOST_MANAGER + 'btsuppliers/add',
      method: 'POST'
    },
    update: {  // 供应商列表修改
      url: SERVER_HOST_MANAGER + 'btsuppliers/update',
      method: 'POST'
    },
  },
  // 标签管理GET /bttags/all
  bttags: {
    all: {  // 标签列表
      url: SERVER_HOST_MANAGER + 'bttags/all',
      method: 'GET'
    },
    add: {  // 标签添加
      url: SERVER_HOST_MANAGER + 'bttags/add',
      method: 'POST'
    },
    delete: {  // 标签删除
      url: SERVER_HOST_MANAGER + 'bttags/delete',
      method: 'GET'
    },
    update: {  // 标签更新
      url: SERVER_HOST_MANAGER + 'bttags/update',
      method: 'POST'
    },
    list: {  // 标签列表
      url: SERVER_HOST_MANAGER + 'bttags/list',
      method: 'POST'
    },
    listGoodsTag: {  // 查询商品对应标签
      url: SERVER_HOST_MANAGER + 'bttags/listGoodsTag',
      method: 'GET'
    },
    disable: {  // 禁用启用
      url: SERVER_HOST_MANAGER + 'bttags/disable',
      method: 'POST'
    },
  },
  //抽奖管理
  btdrawperiod: {
    list: {  //列表
      url: SERVER_HOST_MANAGER + 'btdrawperiod/list',
      method: 'POST'
    },
    add: {  //添加
      url: SERVER_HOST_MANAGER + 'btdrawperiod/add',
      method: 'POST'
    },
    delete: {  //删除
      url: SERVER_HOST_MANAGER + 'btdrawperiod/delete',
      method: 'POST'
    },
    update: {  //更新
      url: SERVER_HOST_MANAGER + 'btdrawperiod/update',
      method: 'POST'
    },
    detail: {  //详情
      url: SERVER_HOST_MANAGER + 'btdrawperiod/detail',
      method: 'GET'
    },
    lotteryRecordList: {  //抽奖记录列表
      url: SERVER_HOST_MANAGER + 'btdrawperiod/lotteryRecordList',
      method: 'POST'
    },
    lotteryPeriodRecordList: {  //该期所有用户的参与记录
      url: SERVER_HOST_MANAGER + 'btdrawperiod/lotteryPeriodRecordList',
      method: 'POST'
    },

  },
  //抽奖商品记录
  appdrawrecords: {
    list: {  //列表
      url: SERVER_HOST_MANAGER + 'appdrawrecords/list',
      method: 'POST'
    },
    listHistory: {  //历史记录列表POST /appdrawrecords//{checkCode}
      url: SERVER_HOST_MANAGER + 'appdrawrecords/listHistory',
      method: 'GET'
    },
    codeRecovery: {  //兑换码恢复
      url: SERVER_HOST_MANAGER + 'appdrawrecords/codeRecovery',
      method: 'POST'
    },
  },
  //中奖兑奖订单
  btdraworders: {
    list: {  //列表
      url: SERVER_HOST_MANAGER + 'btdraworders/list',
      method: 'POST'
    },
    detailAddress: {  //收货信息
      url: SERVER_HOST_MANAGER + 'btdraworders/detailAddress',
      method: 'GET'
    },
    deliver: {  //订单发货
      url: SERVER_HOST_MANAGER + 'btdraworders/deliver',
      method: 'POST'
    },
    consigneeInformation: {  //修改收货人信息
      url: SERVER_HOST_MANAGER + 'btdraworders/consigneeInformation',
      method: 'POST'
    },
    tracking: {  //订单跟踪GET /btdraworders/detailGoods
      url: SERVER_HOST_MANAGER + 'btdraworders/tracking',
      method: 'GET'
    },
    reviewConsigneeInformation: {  //回显收货人信息
      url: SERVER_HOST_MANAGER + 'btdraworders/reviewConsigneeInformation',
      method: 'GET'
    },
    detailGoods: {  //商品信息GET /btdraworders/detailInfo
      url: SERVER_HOST_MANAGER + 'btdraworders/detailGoods',
      method: 'GET'
    },
    detailInfo: {  //基础信息
      url: SERVER_HOST_MANAGER + 'btdraworders/detailInfo',
      method: 'GET'
    },
    detailOperation: {  //操作信息
      url: SERVER_HOST_MANAGER + 'btdraworders/detailOperation',
      method: 'GET'
    },
  },
  //页面管理
  appactivitys: {
    adSpaceDisable: {  //广告位管理-启用/禁用
      url: SERVER_HOST_MANAGER + 'appactivitys/adSpaceDisable',
      method: 'GET'
    },
    adSpaceList: {  //广告位管理(分页)
      url: SERVER_HOST_MANAGER + 'appactivitys/adSpaceList',
      method: 'POST'
    },
    addAdSpace: {  //广告位管理-新增
      url: SERVER_HOST_MANAGER + 'appactivitys/addAdSpace',
      method: 'POST'
    },
    deleteAdSpace: {  //广告位管理-删除
      url: SERVER_HOST_MANAGER + 'appactivitys/deleteAdSpace',
      method: 'GET'
    },
    reviewAdSpace: {  //广告位管理-编辑回显
      url: SERVER_HOST_MANAGER + 'appactivitys/reviewAdSpace',
      method: 'POST'
    },
    updateAdSpace: {  //广告位管理-编辑
      url: SERVER_HOST_MANAGER + 'appactivitys/updateAdSpace',
      method: 'POST'
    },
  },
  //页面管理-首页推荐相关
  btgoodsrecommends: {
    add: {  //新增
      url: SERVER_HOST_MANAGER + 'btgoodsrecommends/add',
      method: 'POST'
    },
    delete: {  //删除
      url: SERVER_HOST_MANAGER + 'btgoodsrecommends/delete',
      method: 'GET'
    },
    disable: {  //启用/禁用
      url: SERVER_HOST_MANAGER + 'btgoodsrecommends/disable',
      method: 'GET'
    },
    goodList: {  //商品列表(分页)
      url: SERVER_HOST_MANAGER + 'btgoodsrecommends/goodsList',
      method: 'POST'
    },
    list: {  //列表(分页)
      url: SERVER_HOST_MANAGER + 'btgoodsrecommends/list',
      method: 'POST'
    },
    review: {  //编辑回显
      url: SERVER_HOST_MANAGER + 'btgoodsrecommends/review',
      method: 'GET'
    },
    update: {  //编辑
      url: SERVER_HOST_MANAGER + 'btgoodsrecommends/update',
      method: 'POST'
    },
  },
  //中奖晒单
  appdrawordershares: {
    add: {  //新增
      url: SERVER_HOST_MANAGER + 'appdrawordershares/add',
      method: 'POST'
    },
    delete: {  //删除
      url: SERVER_HOST_MANAGER + 'appdrawordershares/delete',
      method: 'POST'
    },
    examine: {  //晒单审核
      url: SERVER_HOST_MANAGER + 'appdrawordershares/examine',
      method: 'POST'
    },
    detail: {  //按ID查询详情
      url: SERVER_HOST_MANAGER + 'appdrawordershares/detail',
      method: 'GET'
    },
    list: {  //列表(分页)
      url: SERVER_HOST_MANAGER + 'appdrawordershares/list',
      method: 'POST'
    },
  },
  //平台晒单
  appplatformshare: {
    rePublish: {  //重新发布（编辑）
      url: SERVER_HOST_MANAGER + 'appplatformshare/rePublish',
      method: 'POST'
    },
    getPrePublishInfo: {  //发布晒单详情
      url: SERVER_HOST_MANAGER + 'appplatformshare/getPrePublishInfo',
      method: 'GET'
    },
    publish: {  //发布晒单
      url: SERVER_HOST_MANAGER + 'appplatformshare/publish',
      method: 'POST'
    },
    detail: {  //按ID查询详情
      url: SERVER_HOST_MANAGER + 'appplatformshare/detail',
      method: 'GET'
    },
    platformShareList: {  //列表(分页)
      url: SERVER_HOST_MANAGER + 'appplatformshare/platformShareList',
      method: 'POST'
    },
  },
  //每日福利返佣
  btexpendawardconfigs: {
    addList: {  //批量新增
      url: SERVER_HOST_MANAGER + 'btexpendawardconfigs/addList',
      method: 'POST'
    },
    all: {  //获取所有
      url: SERVER_HOST_MANAGER + 'btexpendawardconfigs/all',
      method: 'POST'
    },
    thisLevels: {   //列表
      url: SERVER_HOST_MANAGER + 'btexpendawardconfigs/thisLevels',
      method: 'GET'
    },
    reviewLevelSimple: {   //回显
      url: SERVER_HOST_MANAGER + 'btexpendawardconfigs/reviewLevelSimple',
      method: 'GET'
    },
    dailyTaskTypesAll: {   // 类型列表
      url: SERVER_HOST_MANAGER + 'btexpendawardconfigs/dailyTaskTypesAll',
      method: 'GET'
    },
    deleteLevelSimple: {   // 类型列表
      url: SERVER_HOST_MANAGER + 'btexpendawardconfigs/deleteLevelSimple',
      method: 'POST'
    },
    reviewUpdateTaskSimple: {   // 回显单个任务
      url: SERVER_HOST_MANAGER + 'btexpendawardconfigs/reviewUpdateTaskSimple',
      method: 'GET'
    },
    updateTaskSimple: {   // 编辑单个任务
      url: SERVER_HOST_MANAGER + 'btexpendawardconfigs/updateTaskSimple',
      method: 'POST'
    },
    updateLevelSimple: {   // 编辑等级
      url: SERVER_HOST_MANAGER + 'btexpendawardconfigs/updateLevelSimple',
      method: 'POST'
    },
    insertLevelSimple: {   // 新增等级
      url: SERVER_HOST_MANAGER + 'btexpendawardconfigs/insertLevelSimple',
      method: 'POST'
    },
  },
  //用户等级配置
  btlevelconfig: {
    list: {  //全量查询
      url: SERVER_HOST_MANAGER + 'btlevelconfig/list',
      method: 'POST'
    },
    trialList: {  //查询等级体验期配置
      url: SERVER_HOST_MANAGER + 'btlevelconfig/trial/list',
      method: 'POST'
    },
    trialUpdate: {   //修改等级体验期配置
      url: SERVER_HOST_MANAGER + 'btlevelconfig/trial/update',
      method: 'POST'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'btlevelconfig/update',
      method: 'POST'
    },
    get: {   //获取
      url: SERVER_HOST_MANAGER + 'btlevelconfig/detail/',
      method: 'GET'
    },
  },
  // 系统角色接口
  roles: {
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'roles/list',
      method: 'POST'
    },
    add: {   //添加
      url: SERVER_HOST_MANAGER + 'roles/add',
      method: 'POST'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'roles/update',
      method: 'POST'
    },
    status: {   //变更角色状态
      url: SERVER_HOST_MANAGER + 'roles/status',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'roles/detail',
      method: 'GET'
    },
    delete: {   //
      url: SERVER_HOST_MANAGER + 'roles/delete',
      method: 'POST'
    },
  },
  syspermissions: { // 系统权限接口
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'syspermissions/list',
      method: 'POST'
    },
    addbatch: {   //多个添加
      url: SERVER_HOST_MANAGER + 'syspermissions/addbatch',
      method: 'POST'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'syspermissions/update',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'syspermissions/detail',
      method: 'GET'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'syspermissions/delete',
      method: 'GET'
    },
  },
  // 权限菜单
  menus: {
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'menus/list',
      method: 'POST'
    },
    add: {   //添加
      url: SERVER_HOST_MANAGER + 'menus/add',
      method: 'POST'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'menus/delete',
      method: 'POST'
    },
    detail: {   //根据id获取详情
      url: SERVER_HOST_MANAGER + 'menus/detail',
      method: 'GET'
    },
    all: {   //权限导航
      url: SERVER_HOST_MANAGER + 'menus/all',
      method: 'POST'
    },
    update: {   //编辑
      url: SERVER_HOST_MANAGER + 'menus/update',
      method: 'POST'
    },
  },
  btcouponrecords: { // 优惠卷
    add: {   //添加
      url: SERVER_HOST_MANAGER + 'btcouponrecords/add',
      method: 'POST'
    },
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btcouponrecords/list',
      method: 'POST'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'btcouponrecords/update',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btcouponrecords/detail',
      method: 'GET'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'btcouponrecords/delete',
      method: 'POST'
    },
    give: {   //批量赠送积分
      url: SERVER_HOST_MANAGER + 'btcouponrecords/give',
      method: 'POST'
    },
  },
  btawardissues: { // 积分发放
    add: {   //添加
      url: SERVER_HOST_MANAGER + 'btawardissues/add',
      method: 'POST'
    },
    issueList: {   //列表
      url: SERVER_HOST_MANAGER + 'btawardissues/issueList',
      method: 'POST'
    },
    issueDataList: {   //详情列表
      url: SERVER_HOST_MANAGER + 'btawardissues/issueDataList',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btawardissues/detail',
      method: 'GET'
    },
    examine: {   //审核
      url: SERVER_HOST_MANAGER + 'btawardissues/examine',
      method: 'POST'
    },
  },
  btchannelss: { // 渠道管理
    add: {   //添加
      url: SERVER_HOST_MANAGER + 'btchannelss/add',
      method: 'POST'
    },
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btchannelss/list',
      method: 'POST'
    },
    listAll: {   //列表
      url: SERVER_HOST_MANAGER + 'btchannelss/listAll',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btchannelss/detail',
      method: 'GET'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'btchannelss/delete',
      method: 'DELETE'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'btchannelss/update',
      method: 'POST'
    },
  },
  btdailydrawgoodss: { // 每日福利
    listAll: {   //列表
      url: SERVER_HOST_MANAGER + 'btdailydrawgoodss/listAll',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btdailydrawgoodss/detail',
      method: 'GET'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'btdailydrawgoodss/update',
      method: 'POST'
    },
    changeChance: {   //保存概率
      url: SERVER_HOST_MANAGER + 'btdailydrawgoodss/changeChance',
      method: 'POST'
    },
  },
  btdailycheckingoods: { // 每日签到配置
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btdailycheckingoods/list',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btdailycheckingoods/detail',
      method: 'GET'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'btdailycheckingoods/update',
      method: 'POST'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'btdailycheckingoods/delete',
      method: 'GET'
    },
    add: {   //新增
      url: SERVER_HOST_MANAGER + 'btdailycheckingoods/add',
      method: 'POST'
    },
  },
  btdailycheckinrecord: { // 每日签到记录
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btdailycheckinrecord/list',
      method: 'POST'
    },
  },
  btdailyrebaterecord: { // 返利记录
    list: {   //分页
      url: SERVER_HOST_MANAGER + 'btdailyrebaterecord/list',
      method: 'POST'
    },
    detail: {   //等级变更明细
      url: SERVER_HOST_MANAGER + 'btdailyrebaterecord/changelog/list',
      method: 'POST'
    },
  },
  btcoupons: { // 优惠卷管理
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btcoupons/list',
      method: 'POST'
    },
    add: {   //添加
      url: SERVER_HOST_MANAGER + 'btcoupons/add',
      method: 'POST'
    },
    disable: {   //启用禁用
      url: SERVER_HOST_MANAGER + 'btcoupons/disable',
      method: 'POST'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'btcoupons/delete',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btcoupons/detail',
      method: 'GET'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'btcoupons/update',
      method: 'POST'
    },
    batchEnable: {   //批量启用
      url: SERVER_HOST_MANAGER + 'btcoupons/batchEnable',
      method: 'POST'
    },
    batchDisable: {   //批量禁用
      url: SERVER_HOST_MANAGER + 'btcoupons/batchDisable',
      method: 'POST'
    },
  },
  appfundrecords: { // 提现管理
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'appfundrecords/list',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'appfundrecords/detail',
      method: 'GET'
    },
    audit: {   //详情
      url: SERVER_HOST_MANAGER + 'appfundrecords/audit',
      method: 'POST'
    },
  },
  btexchangegoods: { // 积分兑换商品
    changeInventory: {   //编辑
      url: SERVER_HOST_MANAGER + 'btexchangegoods/changeInventory',
      method: 'POST'
    },
    changeStatus: {   // 添加商品
      url: SERVER_HOST_MANAGER + 'btexchangegoods/changeStatus',
      method: 'POST'
    },
    list: {
      url: SERVER_HOST_MANAGER + 'btexchange/list',
      method: 'POST'
    },
    add: {
      url: SERVER_HOST_MANAGER + 'btexchange/add',
      method: 'POST'
    },
    remove: {
      url: SERVER_HOST_MANAGER + 'btexchange/delete',
      method: 'POST'
    },
    detail: {
      url: SERVER_HOST_MANAGER + 'btexchange/detail',
      method: 'GET'
    },
    update: {
      url: SERVER_HOST_MANAGER + 'btexchange/update',
      method: 'POST'
    },
    state: {   //上下架
      url: SERVER_HOST_MANAGER + 'btexchange/state',
      method: 'POST'
    },
  },
  // 积分兑换订单
  btexchangeorder: {
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btexchangeorder/list',
      method: 'POST'
    },
    orderDetail: {   // 物流信息
      url: SERVER_HOST_MANAGER + 'btlogistics/detailByOrderId',
      method: 'GET'
    },
    updateLogistics: {   // 更新物流单号
      url: SERVER_HOST_MANAGER + 'btlogistics/update',
      method: 'POST'
    },
  },
  btdailylottery: {   // 积分抽奖
    add: {   //添加
      url: SERVER_HOST_MANAGER + 'btdailylottery/add',
      method: 'POST'
    },
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btdailylottery/list',
      method: 'POST'
    },
    detail: {   //参与明细
      url: SERVER_HOST_MANAGER + 'btdailylottery/detail',
      method: 'GET'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'btdailylottery/delete',
      method: 'POST'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'btdailylottery/update',
      method: 'POST'
    },
    state: {   //上下架
      url: SERVER_HOST_MANAGER + 'btdailylottery/state',
      method: 'POST'
    },
  },
  // 积分抽奖-参与明细
  btdailylotteryorder: {
    list: {   //列表-抽奖记录
      url: SERVER_HOST_MANAGER + 'btdailylotteryorder/list',
      method: 'POST'
    },
    logistics: {   // 更新物流单号
      url: SERVER_HOST_MANAGER + 'btdailylotteryorder/logistics',
      method: 'POST'
    },
  },
  // 淘豆竞猜
  btquizperiods: {
    list: {   //列表-竞猜记录
      url: SERVER_HOST_MANAGER + 'btquizperiods/list',
      method: 'POST'
    },
    listDetail: {   //列表-竞猜记录
      url: SERVER_HOST_MANAGER + 'btquizperiods/listDetail',
      method: 'POST'
    },
    quizRecordList: {   //列表
      url: SERVER_HOST_MANAGER + 'btquizperiods/quizRecordList',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btquizperiods/detail',
      method: 'GET'
    },
    reviewConfig: {   //回显淘豆竞猜配置
      url: SERVER_HOST_MANAGER + 'btquizperiods/reviewConfig',
      method: 'POST'
    },
    updateConfig: {   // 编辑赔率，上限
      url: SERVER_HOST_MANAGER + 'btquizperiods/updateConfig',
      method: 'POST'
    },
    updateQuizBeeton: {   // 编辑淘豆选项
      url: SERVER_HOST_MANAGER + 'btquizperiods/updateQuizBeeton',
      method: 'POST'
    },
    updateQuizTime: {   // 编辑取值时间
      url: SERVER_HOST_MANAGER + 'btquizperiods/updateQuizTime',
      method: 'POST'
    },
    reviewOdds: {   // 查询倍率
      url: SERVER_HOST_MANAGER + 'btquizperiods/reviewOdds',
      method: 'POST'
    },
    modifiedOdds: {   // 修改倍率
      url: SERVER_HOST_MANAGER + 'btquizperiods/modifiedOdds',
      method: 'POST'
    },
  },
  // 世界杯竞猜
  worldCupGuess: {
    list: {
      url: SERVER_HOST_MANAGER + 'btworldcupmatch/list',
      method: 'POST'
    },
    add: {
      url: SERVER_HOST_MANAGER + 'btworldcupmatch/add',
      method: 'POST'
    },
    update: {
      url: SERVER_HOST_MANAGER + 'btworldcupmatch/update',
      method: 'POST'
    },
    online: {
      url: SERVER_HOST_MANAGER + 'btworldcupmatch/online',
      method: 'POST'
    },
    offline: {
      url: SERVER_HOST_MANAGER + 'btworldcupmatch/offline',
      method: 'POST'
    },
    close: {
      url: SERVER_HOST_MANAGER + 'btworldcupmatch/closeBet',
      method: 'POST'
    },
    delete: {
      url: SERVER_HOST_MANAGER + 'btworldcupmatch/delete',
      method: 'POST'
    },
    settle: {
      url: SERVER_HOST_MANAGER + 'btworldcupmatch/settlement',
      method: 'POST'
    },
    records: {
      url: SERVER_HOST_MANAGER + 'btworldcupmatch/betRecordList',
      method: 'POST'
    },
    betConfig: {
      url: SERVER_HOST_MANAGER + 'btbetconfig/detail',
      method: 'GET'
    },
    saveBetConfig: {
      url: SERVER_HOST_MANAGER + 'btbetconfig/update',
      method: 'POST'
    },
    participantConfig: {
      url: SERVER_HOST_MANAGER + 'btworldcupmatchinitconfig/detail',
      method: 'GET'
    },
    saveParticipantConfig: {
      url: SERVER_HOST_MANAGER + 'btworldcupmatchinitconfig/update',
      method: 'POST'
    },
  },
  // 世界杯球队
  worldCupTeam: {
    add: {
      url: SERVER_HOST_MANAGER + 'btworldcupteam/add',
      method: 'POST'
    },
    list: {
      url: SERVER_HOST_MANAGER + 'btworldcupteam/list',
      method: 'POST'
    },
    update: {
      url: SERVER_HOST_MANAGER + 'btworldcupteam/update',
      method: 'POST'
    },
    delete: {
      url: SERVER_HOST_MANAGER + 'btworldcupteam/delete',
      method: 'POST'
    },
    detail: {
      url: SERVER_HOST_MANAGER + 'btworldcupteam/detail',
      method: 'GET'
    },
    listAll: {
      url: SERVER_HOST_MANAGER + 'btworldcupteam/listAll',
      method: 'GET'
    },
  },
  // 回访记录
  appuservisiteds: {
    add: {   //添加
      url: SERVER_HOST_MANAGER + 'appuservisiteds/add',
      method: 'POST'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'appuservisiteds/delete',
      method: 'POST'
    },
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'appuservisiteds/list',
      method: 'POST'
    },
  },
  btconsumerewardconfigs: { // 用户邀请配置
    updateBtInviteRewardConfig: {   //积分邀请配置
      url: SERVER_HOST_MANAGER + 'btconsumerewardconfigs/updateBtInviteRewardConfig',
      method: 'POST'
    },
    getInviteRewardDetail: {   //积分邀请配置详情
      url: SERVER_HOST_MANAGER + 'btconsumerewardconfigs/getInviteRewardDetail',
      method: 'GET'
    },
    getLevelAndConsume: {   //等级配置列表
      url: SERVER_HOST_MANAGER + 'btconsumerewardconfigs/getLevelAndConsume',
      method: 'GET'
    },
    addLevel: {   //等级保存
      url: SERVER_HOST_MANAGER + 'btconsumerewardconfigs/addLevel',
      method: 'POST'
    },
  },
  //禁用设备
  btrisks: {
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btrisks/list',
      method: 'POST'
    },
    add: {   //新增
      url: SERVER_HOST_MANAGER + 'btrisks/add',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btrisks/detail',
      method: 'GET'
    },
    setStatus: {   //启用禁用
      url: SERVER_HOST_MANAGER + 'btrisks/setStatus',
      method: 'POST'
    },
  },
  //禁用详情列表
  btriskdetails: {
    listPageByRiskId: {   //列表
      url: SERVER_HOST_MANAGER + 'btriskdetails/listPageByRiskId',
      method: 'POST'
    },
  },
  //异常注册或登录
  btriskmobiles: {
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btriskmobiles/list',
      method: 'POST'
    },
    add: {   //新增
      url: SERVER_HOST_MANAGER + 'btriskmobiles/add',
      method: 'POST'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'btriskmobiles/delete',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btriskmobiles/detail',
      method: 'GET'
    },
    setStatus: {   //启用禁用
      url: SERVER_HOST_MANAGER + 'btriskmobiles/setStatus',
      method: 'POST'
    },
    update: {   //编辑
      url: SERVER_HOST_MANAGER + 'btriskmobiles/update',
      method: 'POST'
    },
  },
  //支付策略
  btpaymenttacticsrule: {
    list: {   //规则列表
      url: SERVER_HOST_MANAGER + 'btpaymenttacticsrule/list',
      method: 'POST'
    },
  },
  btpaymenttacticsprovider: {
    init: {   //支付方式列表
      url: SERVER_HOST_MANAGER + 'btpaymenttacticsprovider/init',
      method: 'POST'
    },
  },
  //用户标签相关
  btusertagrules: {
    list: {   //规则列表POST //list
      url: SERVER_HOST_MANAGER + 'btusertagrules/list',
      method: 'POST'
    },
    checkInRuleUserId: {   //筛选策略用户
      url: SERVER_HOST_MANAGER + 'btusertagrules/checkInRuleUserId',
      method: 'POST'
    },
    reviewSe: {   //弹窗策略和启动页列表
      url: SERVER_HOST_MANAGER + 'btusertagrules/reviewSe',
      method: 'GET'
    },
    updateSe: {   //保存弹窗策略和启动页列表
      url: SERVER_HOST_MANAGER + 'btusertagrules/updateSe',
      method: 'GET'
    },
  },
  //路由基础配置
  btrouteconfigs: {
    listAll: {   // 列表
      url: SERVER_HOST_MANAGER + 'btrouteconfigs/listAll',
      method: 'POST'
    },
  },
  // 弹窗管理
  btpopupconfigs: {
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btpopupconfigs/list',
      method: 'POST'
    },
    disable: {   //启用禁用
      url: SERVER_HOST_MANAGER + 'btpopupconfigs/disable',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btpopupconfigs/detail',
      method: 'GET'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'btpopupconfigs/delete',
      method: 'POST'
    },
    add: {   // 添加
      url: SERVER_HOST_MANAGER + 'btpopupconfigs/add',
      method: 'POST'
    },
    update: {   // 更新
      url: SERVER_HOST_MANAGER + 'btpopupconfigs/update',
      method: 'POST'
    },
  },
  // app配置
  appconfig: {
    add: {
      url: SERVER_HOST_MANAGER + 'appconfig/add',
      method: 'POST'
    },
    changeStatus: {
      url: SERVER_HOST_MANAGER + 'appconfig/changeStatus',
      method: 'POST'
    },
    pageList: {
      url: SERVER_HOST_MANAGER + 'appconfig/pageList',
      method: 'POST'
    },
    update: {
      url: SERVER_HOST_MANAGER + 'appconfig/update',
      method: 'POST'
    },
    detail: {
      url: SERVER_HOST_MANAGER + 'appconfig/',
      method: 'GET'
    },
    delete: {
      url: SERVER_HOST_MANAGER + 'appconfig/delete',
      method: 'POST'
    }
  },
  // app积分发放接口
  appcreditrecords: {
    listRecord: {   //列表
      url: SERVER_HOST_MANAGER + 'appcreditrecords/listRecord',
      method: 'POST'
    },
  },
  //用户标签相关
  btusertags: {
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btusertags/list',
      method: 'POST'
    },
    disable: {   //启用禁用
      url: SERVER_HOST_MANAGER + 'btusertags/disable',
      method: 'POST'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'btusertags/delete',
      method: 'POST'
    },
    add: {   //新增
      url: SERVER_HOST_MANAGER + 'btusertags/add',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btusertags/detail',
      method: 'GET'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'btusertags/update',
      method: 'POST'
    },
  },
  //用户app端导航
  btpagemenuconfigs: {
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btpagemenuconfigs/list',
      method: 'POST'
    },
    disable: {   //启用禁用
      url: SERVER_HOST_MANAGER + 'btpagemenuconfigs/disable',
      method: 'POST'
    },
    dataListAll: {   //页面类型全部列表
      url: SERVER_HOST_MANAGER + 'btpagemenuconfigs/dataListAll',
      method: 'POST'
    },
    dataListAllDetail: {   //页面类型列表-对应item选项
      url: SERVER_HOST_MANAGER + 'btpagemenuconfigs/dataListAllDetail',
      method: 'GET'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'btpagemenuconfigs/delete',
      method: 'POST'
    },
    add: {   //新增
      url: SERVER_HOST_MANAGER + 'btpagemenuconfigs/add',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btpagemenuconfigs/detail',
      method: 'GET'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'btpagemenuconfigs/update',
      method: 'POST'
    },
    sort: {   //策略保存
      url: SERVER_HOST_MANAGER + 'btpagemenuconfigs/sort',
      method: 'POST'
    },
    updateDefault: {   //策略保存
      url: SERVER_HOST_MANAGER + 'btpagemenuconfigs/updateDefault',
      method: 'POST'
    },
  },
  // 推送管理
  btjpushrecords: {
    list: {   // 列表
      url: SERVER_HOST_MANAGER + 'btjpushrecords/list',
      method: 'POST'
    },
    delete: {   // 删除
      url: SERVER_HOST_MANAGER + 'btjpushrecords/delete',
      method: 'POST'
    },
    add: {   // 新增
      url: SERVER_HOST_MANAGER + 'btjpushrecords/add',
      method: 'POST'
    },
    pushNow: {   // 立即推送
      url: SERVER_HOST_MANAGER + 'btjpushrecords/pushNow',
      method: 'POST'
    },
    detail: {   // 详情
      url: SERVER_HOST_MANAGER + 'btjpushrecords/detail',
      method: 'GET'
    },
    update: {   // 更新
      url: SERVER_HOST_MANAGER + 'btjpushrecords/update',
      method: 'POST'
    },
  },
  //支付策略管理
  btpaymenttacticss: {
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btpaymenttacticss/list',
      method: 'POST'
    },
    add: {   //新增
      url: SERVER_HOST_MANAGER + 'btpaymenttacticss/add',
      method: 'POST'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'btpaymenttacticss/delete',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btpaymenttacticss/detail',
      method: 'GET'
    },
    disable: {   //启用禁用
      url: SERVER_HOST_MANAGER + 'btpaymenttacticss/disable',
      method: 'POST'
    },
    update: {   //编辑
      url: SERVER_HOST_MANAGER + 'btpaymenttacticss/update',
      method: 'POST'
    },
    verifyIdMobile: {   //校验
      url: SERVER_HOST_MANAGER + 'btpaymenttacticss/verifyIdMobile',
      method: 'POST'
    },
  },
  //QA分类相关
  btqacategorys: {
    listAll: {   //列表
      url: SERVER_HOST_MANAGER + 'btqacategorys/listAll',
      method: 'POST'
    },
    add: {   //新增
      url: SERVER_HOST_MANAGER + 'btqacategorys/add',
      method: 'POST'
    },
    deleteA: {   //二级删除
      url: SERVER_HOST_MANAGER + 'btqacategorys/deleteA',
      method: 'POST'
    },
    deleteB: {   //三级删除POST /btqacategorys/
      url: SERVER_HOST_MANAGER + 'btqacategorys/deleteB',
      method: 'POST'
    },
    update: {   //更新
      url: SERVER_HOST_MANAGER + 'btqacategorys/update',
      method: 'POST'
    },
    review: {   //详情POST /btqacategorys/
      url: SERVER_HOST_MANAGER + 'btqacategorys/review',
      method: 'GET'
    },
    addInfo: {   //添加问题
      url: SERVER_HOST_MANAGER + 'btqacategorys/addInfo',
      method: 'POST'
    },
    updateInfo: {   //更新问题
      url: SERVER_HOST_MANAGER + 'btqacategorys/updateInfo',
      method: 'POST'
    },
  },
  // 聊天室
  approoms: {
    listAll: {   // 聊天室列表
      url: SERVER_HOST_MANAGER + 'approoms/listAll',
      method: 'POST'
    },
    listBy: {   // 聊天室列表(有条件)
      url: SERVER_HOST_MANAGER + 'approoms/listBy',
      method: 'GET'
    },
    addRoom: {   // 新增聊天室
      url: SERVER_HOST_MANAGER + 'approoms/addRoom',
      method: 'POST'
    },
    addSysUser: {   // 新增管理员
      url: SERVER_HOST_MANAGER + 'approoms/addSysUser',
      method: 'POST'
    },
    addAppUser: {   // 新增管理员
      url: SERVER_HOST_MANAGER + 'approoms/addAppUser',
      method: 'POST'
    },
    userList: {   // 聊天成员列表
      url: SERVER_HOST_MANAGER + 'approoms/userList',
      method: 'POST'
    },
    userListAll: {   // 聊天成员列表(不分页)
      url: SERVER_HOST_MANAGER + 'approoms/userListAll',
      method: 'POST'
    },
    updateRoom: {   // 编辑聊天室
      url: SERVER_HOST_MANAGER + 'approoms/updateRoom',
      method: 'POST'
    },
    detail: {   // 聊天室详情
      url: SERVER_HOST_MANAGER + 'approoms/detail',
      method: 'GET'
    },
    delete: {   // 删除聊天室
      url: SERVER_HOST_MANAGER + 'approoms/delete',
      method: 'POST'
    },
    disbandRoom: {   // 解散聊天室
      url: SERVER_HOST_MANAGER + 'approoms/disbandRoom',
      method: 'POST'
    },
    deleteApp: {   // 删除用户（取消管理员）
      url: SERVER_HOST_MANAGER + 'approoms/deleteApp',
      method: 'POST'
    },
    updateMuteUser: {   // 编辑用户禁言
      url: SERVER_HOST_MANAGER + 'approoms/updateMuteUser',
      method: 'POST'
    },
    listMessage: {   // 消息记录列表
      url: SERVER_HOST_MANAGER + 'approoms/listMessage',
      method: 'GET'
    },
    listRedPacket: {   // 聊天室红包记录
      url: SERVER_HOST_MANAGER + 'approoms/listRedPacket',
      method: 'POST'
    },
    sendCoupon: {   // 发送优惠卷
      url: SERVER_HOST_MANAGER + 'approoms/sendCoupon',
      method: 'POST'
    },
    redPacketReciveRecord: {   // 红包详情
      url: SERVER_HOST_MANAGER + 'approoms/redPacketReciveRecord',
      method: 'GET'
    },
    deleteMessage: {   // 红包详情
      url: SERVER_HOST_MANAGER + 'approoms/deleteMessage',
      method: 'POST'
    },
    couponReceivedRecord: {   // 优惠卷详情
      url: SERVER_HOST_MANAGER + 'approoms/couponReceivedRecord',
      method: 'POST'
    },
    updateRoomName: {   // 编辑聊天室名称
      url: SERVER_HOST_MANAGER + 'approoms/updateRoomName',
      method: 'POST'
    },
  },
  // 聊天室操作日志
  approomlogss: {
    list: {   //列表/logTypesAll
      url: SERVER_HOST_MANAGER + 'approomlogss/list',
      method: 'POST'
    },
    logTypesAll: {   //下拉列表
      url: SERVER_HOST_MANAGER + 'approomlogss/logTypesAll',
      method: 'POST'
    },
  },
  // 在线客服
  btserviceconfigs: {
    list: {   //客服列表
      url: SERVER_HOST_MANAGER + 'btserviceconfigs/list',
      method: 'POST'
    },
    unAddSysUserList: {   //待添加客服列表
      url: SERVER_HOST_MANAGER + 'btserviceconfigs/unAddSysUserList',
      method: 'GET'
    },
    addService: {   //添加客服
      url: SERVER_HOST_MANAGER + 'btserviceconfigs/addService',
      method: 'POST'
    },
    delete: {   //删除客服{serviceId}
      url: SERVER_HOST_MANAGER + 'btserviceconfigs/delete',
      method: 'DELETE'
    },
    setManeger: {   //添加客服主管{serviceId}
      url: SERVER_HOST_MANAGER + 'btserviceconfigs/setManeger',
      method: 'POST'
    },
    updateOnline: {   //客服上下线
      url: SERVER_HOST_MANAGER + 'btserviceconfigs/updateOnline',
      method: 'POST'
    },
    autoReplyConfig: {   //自动回复设置
      url: SERVER_HOST_MANAGER + 'btserviceconfigs/autoReplyConfig',
      method: 'POST'
    },
    autoReplyShow: {   //自动回复回显
      url: SERVER_HOST_MANAGER + 'btserviceconfigs/autoReplyShow',
      method: 'POST'
    },
  },
  // 发送验证码
  sms: {
    sendCode: {   //发送验证码
      url: SERVER_HOST_MANAGER + 'sms/sendCode',
      method: 'POST'
    },
    smsLogin: {   //短信登录
      url: SERVER_HOST_MANAGER + 'smsLogin',
      method: 'POST'
    },
  },
  // 在线客服关联用户
  btservicerelations: {
    listAll: {   //用户列表
      url: SERVER_HOST_MANAGER + 'btservicerelations/listAll',
      method: 'POST'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btservicerelations/detail',
      method: 'GET'
    },
    addService: {   //抢接、转接
      url: SERVER_HOST_MANAGER + 'btservicerelations/transfer',
      method: 'POST'
    },
  },
  // 消息
  btservicemessages: {
    listMessage: {   //消息记录
      url: SERVER_HOST_MANAGER + 'btservicemessages/listMessage',
      method: 'GET'
    },
    detail: {   //详情
      url: SERVER_HOST_MANAGER + 'btservicemessages/detail',
      method: 'GET'
    },
    deleteMessage: {   //删除消息
      url: SERVER_HOST_MANAGER + 'btservicemessages/deleteMessage',
      method: 'POST'
    },
    readMessage: {   //已读消息
      url: SERVER_HOST_MANAGER + 'btservicemessages/readMessage',
      method: 'POST'
    },
  },
  // 快捷回复
  btservicereplyclassifys: {
    add: {   //新增
      url: SERVER_HOST_MANAGER + 'btservicereplyclassifys/add',
      method: 'POST'
    },
    delete: {   //删除
      url: SERVER_HOST_MANAGER + 'btservicereplyclassifys/delete',
      method: 'POST'
    },
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btservicereplyclassifys/list',
      method: 'GET'
    },
    update: {   //编辑
      url: SERVER_HOST_MANAGER + 'btservicereplyclassifys/update',
      method: 'POST'
    },
  },
  // 备注接口POST /btservicedailys/listAll
  btservicedailys: {
    add: {   //新增
      url: SERVER_HOST_MANAGER + 'btservicedailys/add',
      method: 'POST'
    },
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btservicedailys/list',
      method: 'POST'
    },
    listAll: {   //列表(不分页)
      url: SERVER_HOST_MANAGER + 'btservicedailys/listAll',
      method: 'POST'
    },
  },
  // 定时任务接口
  btroommessagetimepushs: {
    list: {   //列表
      url: SERVER_HOST_MANAGER + 'btroommessagetimepushs/list',
      method: 'POST'
    },
    listAll: {   //定时发送列表
      url: SERVER_HOST_MANAGER + 'btroommessagetimepushs/listAll',
      method: 'POST'
    },
    save: {   //定时发送列表
      url: SERVER_HOST_MANAGER + 'btroommessagetimepushs/save',
      method: 'POST'
    },
  },
};
module.exports = API;




// WEBPACK FOOTER //
// ./src/common/constants.js